import {VideoStateMgrGen} from "./ms-state-controller-gen";

const lowConnTimeout = 20;
const failTimeout = 10;
const maxStableConn = 5;

export class VideoStateMgrIos extends VideoStateMgrGen{
  constructor(autoplay, restMS, displayErrorPanel, restartPlayer) {
    console.log('Load IOS');
    super(autoplay, restMS, displayErrorPanel, restartPlayer);
    this.videoEl = null;
    this.firstPlay = true;
  }

  setPlayer(player, start = false) {
    console.log('----> setPlayer IOS');
    super.setPlayer(player, start);
    this.videoEl = player.core.el.querySelector('video');
    if (this.videoEl) {
      this.videoEl.addEventListener('stalled', (e) => {
        // If stalled and running, check stream is active and running and show error message if needed
        console.log('stalled --->', e, this.streamState);
      });

      this.videoEl.addEventListener("webkitendfullscreen", () => {
        console.log('CLOSE FULLSCREEN!!');
      }, false);

      this.videoEl.addEventListener('ended', (e) => {
        console.log('----- ended', e);
      });
    }
  }
}
